import { RemoteConfigLoader } from "./RemoteConfigLoader"

export type Endpoint = "api" | "aggregator" | "power-simulator" | "sensor-config"

/**
 *
 */
interface ConfigContent {
    /**
     *
     */
    readonly inDevelopment: boolean
}
/**
 * Url Configuration helper class
 */
class ApplicationOptionsIn extends RemoteConfigLoader<ConfigContent> {
    protected url: string = "/options.json"
}

export const ApplicationOptions = new ApplicationOptionsIn()